module.exports = __webpack_public_path__ + "static/img/empty-data.885f83f5.png";